import { getUser } from "@/components/session/JwtTokenManager";
import { UserCurrentSite } from "@/graphql";
import { CoachingCustomer, CoachingCurrentUser } from "@/types/users";

import { FEATURE_CONFIGS } from "./constants";

interface EnableFeatureProps {
  featureName: keyof typeof FEATURE_CONFIGS;
  defaultValue: boolean;
  user?: CoachingCurrentUser | CoachingCustomer | null;
}

export function enableFeature({
  featureName = "enableJobSearch",
  defaultValue = true,
  user,
}: EnableFeatureProps) {
  const currentUser = user ? user : getUser();

  if (currentUser?.configuration) {
    if (featureName in currentUser.configuration) {
      return currentUser.configuration[featureName];
    }
  }

  return defaultValue;
}

export function enableReviews(
  user?: CoachingCurrentUser | CoachingCustomer | null,
) {
  return enableFeature({
    featureName: "enableReviews",
    defaultValue: true,
    user,
  });
}

export function enableJobSearch(
  user?: CoachingCurrentUser | CoachingCustomer | null,
) {
  return enableFeature({
    featureName: "enableJobSearch",
    defaultValue: true,
    user,
  });
}

export function getCurrentSite() {
  return IS_EXEC ? UserCurrentSite.Exec : UserCurrentSite.Placement;
}
